import Rest from '../../Server/Rest';
import config from '../../settings/config';

// Consulta para obtener el XLS
export const fetchXLS = async ({
  className,
  where,
  order,
  include,
  type,
  format,
}) => {
  const res = await Rest.peticion(`${config.api_url}/functions/getXLS`, {
    method: 'POST',
    body: JSON.stringify({
      className,
      where,
      order,
      include,
      type,
      format,
    }),
  });
  return res.json();
};
